window.SwymWishlist = window.SwymWishlist || {};

SwymWishlist.formatMoney = function(cents) {
  const formatter = new Intl.NumberFormat(Shopify.locale || 'en', {
    style: 'currency',
    currency: Shopify.currency?.active || 'USD'
  });
  return formatter.format(cents / 100);
};

SwymWishlist.updateCounter = function(count) {
  const countEl = document.getElementById('swym-wishlist-count');
  if (countEl) countEl.textContent = count;
};
